<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>发布招标书</el-breadcrumb-item>
            </el-breadcrumb>

        </div>

        <div class="bidding-container" style="width: 1100px;margin: 0 auto;">
            <h1 class="main-title">招 标 书</h1>
            <div class="bidding-intro">
                <div class="content-caption dashed font18" style="background-color: #fff">
                    <span><span class="color-laber"></span>招标流程简介</span>
                </div>
                <p class="intro-text">商维宝招投标采购，招标人可以公开招投标，也可以邀请招投标。公开招标方式下报名的供应商以及被邀标方式下被邀请的的供应商均需要经过报名流程并且通过采购商的资质审核后，才可以正式参与投标、提交投标文件。 </p>
                <div class="bidding-proc"></div>

            </div>
            <el-form :model="callBidDoc" ref="bidDoc" :rules="rules">
                <div class="bidding-form-wrap">
                    <fieldset>
                        <div class="content-caption required dashed">
                            <span class="">招标标题</span>
                        </div>
                        <el-form-item prop="title">
                            <el-input class="width-3x" v-model="callBidDoc.title" placeholder="为该招标单写个标题（必填）"></el-input>
                        </el-form-item>
                    </fieldset>


                    <fieldset>
                        <div class="content-caption dashed">
                            <span>招标预算</span>
                        </div>
                        <div>
                            <el-radio-group v-model="callBidDoc.budgetFlag">
                                <el-radio :label="0">无预算</el-radio>
                                <el-radio :label="2">固定总额</el-radio>
                            </el-radio-group>
                        </div>
                        <div v-if="callBidDoc.budgetFlag == 2">
                            <el-form-item class="mr20" prop="budgetAmount">
                                <el-input style="width: 200px" v-model="callBidDoc.budgetAmount" placeholder="请输入金额"></el-input>&nbsp;&nbsp;<span>单位（元）</span>
                            </el-form-item>
                            <!--<div style="margin-top: 10px;" class="ml30" v-if="callBidDoc.budgetFlag == 2">-->
                            <!--<el-input style="width: 200px" v-model="callBidDoc.budgetAmount" placeholder="请输入金额"></el-input>&nbsp;&nbsp;<span>单位（元）</span>-->
                            <!--</div>-->
                        </div>
                    </fieldset>

                    <!-- 商品/服务选择详情 -->
                    <swb-create-call-item :vendor="vendor" :id="callbidDocId" ref="swb_create_call_item"></swb-create-call-item>

                    <fieldset>
                        <div class="content-caption dashed">
                            <span>招标方式</span>
                        </div>
                        <div>
                            <el-radio-group v-model="callBidDoc.directed">
                                <el-radio :label="false">公开招标</el-radio>
                                <el-radio :label="true">定向招标</el-radio>
                            </el-radio-group>
                            <span v-if="callBidDoc.directed==true"><a class="ml10" style="color: blue;" @click="showCallbidTargetsDialog">[ 选择 ]</a> <a v-show="directedMerchantList.length >0" class="ml10" style="color: blue;" @click="clearCallbidTargets"> 清除所选 </a></span>
                        </div>
                        <div v-if="callBidDoc.directed==true" class="ml15 mt20">
                            <div v-if="callBidDoc.directed==true" class="ml15">
                                <div>
                                    <span>{{directedMerchantList.pluck('name').join('、')}}</span>
                                </div>
                            </div>
                        </div>
                        <br/>
                    </fieldset>

                    <fieldset>
                        <div class="simple-form">
                            <div class="form-group center">
                                <div class="form-label">
                                    <label class="required">上传招标书</label>
                                </div>
                                <div class="form-value">
                                    <swb-file-upload fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                                    <div class="file-area clearfix">
                                        <swb-file-item v-for="(file, index) in fileList" :trackKey="index" :editable="true" :tag="file.tag" :fileName="file.name" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl" :fileDownloadUrl="file.fileDownloaddUrl" :fileMd5="file.fileMd5" :deletable="true" :onDelete="removeUpload" :onUploaded="echoUploadedFileInfo"></swb-file-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <div class="content-caption required dashed">
                            <span>内容摘要</span>
                        </div>
                        <div class="simple-form">
                            <div class="form-group center">
                                <div class="form-label">
                                    <label>内容摘要</label>
                                </div>
                                <div class="form-value width-2x">
                                    <el-form-item prop="digest">
                                        <el-input type="textarea" :rows="3" class="width-3x" v-model="callBidDoc.digest" placeholder="请输入内容摘要"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <div class="content-caption dashed">
                            <span>报名/投标时间</span>
                        </div>
                        <div class="simple-form">
                            <div class="form-group center">
                                <div class="form-label ">
                                    <label class="required"></label>
                                </div>
                                <div class="form-value width-2x">
                                    <el-form-item prop="enrollCloseTime">
                                        <el-date-picker v-model="callBidDoc.enrollCloseTime" :picker-options="pickerOptions0" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="选择日期"></el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group center">
                                <div class="form-label ">
                                    <label class="required">资格预审结束</label>
                                </div>
                                <div class="form-value width-2x">
                                    <el-form-item prop="openTime">
                                        <el-date-picker v-model="callBidDoc.openTime" :picker-options="pickerOptions0" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="选择日期"></el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group center">
                                <div class="form-label ">
                                    <label class="required">投标截止时间</label>
                                </div>
                                <div class="form-value width-2x">
                                    <el-form-item prop="closeTime">
                                        <el-date-picker v-model="callBidDoc.closeTime" :picker-options="pickerOptions0" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="选择日期"></el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group center">
                                <div class="form-label ">
                                    <label class="required">公布结果时间</label>
                                </div>
                                <div class="form-value width-2x">
                                    <el-form-item prop="resultPublishTime">
                                        <el-date-picker v-model="callBidDoc.resultPublishTime" :picker-options="pickerOptions0" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="选择日期"></el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <div class="content-caption dashed">
                            <span>联系方式</span>
                        </div>
                        <div class="simple-form">
                            <div class="form-group center">
                                <div class="form-label ">
                                    <label class="required">联系人</label>
                                </div>
                                <div class="form-value width-2x">
                                    <el-form-item prop="contactName">
                                        <el-input v-model="callBidDoc.contactName" class="width-1x" placeholder="请输入内容"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group center">
                                <div class="form-label ">
                                    <label class="required">联系方式</label>
                                </div>
                                <div class="form-value width-2x">
                                    <el-form-item prop="contactTel">
                                        <el-input class="width-1x" v-model="callBidDoc.contactTel" placeholder="请输入联系方式"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group center">
                                <div class="form-label">
                                    <label>电子邮箱</label>
                                </div>
                                <div class="form-value width-2x">
                                    <el-form-item prop="contactEmail">
                                        <el-input class="width-1x" v-model="callBidDoc.contactEmail" placeholder="请输入联系方式"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <div class="content-caption dashed">
                            <span>招标要求</span>
                        </div>
                        <div class="simple-form">
                            <div class="form-group center">
                                <div class="form-label">
                                    <label>报名费</label>
                                </div>
                                <div class="form-value">
                                    <el-radio-group v-model="callBidDoc.enrollFree">
                                        <el-radio :label="true">免费</el-radio>
                                        <el-radio :label="false">收费</el-radio>
                                    </el-radio-group>
                                    <div v-if="!callBidDoc.enrollFree">
                                        <el-form-item prop="enrollFee">
                                            <el-input class="width-1-5x" v-model="callBidDoc.enrollFee" placeholder="请输入金额"></el-input>&nbsp;&nbsp;<span>单位(元)</span>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group center">
                                <div class="form-label ">
                                    <label class="required">保证金</label>
                                </div>
                                <div class="form-value">
                                    <el-form-item prop="reqDeposit">
                                        <el-input class="width-1x" v-model="callBidDoc.reqDeposit" placeholder="请输入金额"></el-input>&nbsp;&nbsp;<span>单位(元)</span>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group center">
                                <div class="form-label">
                                    <label>资质要求</label>
                                </div>
                                <div class="form-value">
                                    <span><a style="color: blue;" @click="selectQualiTypes">[ 选择 ]</a> <a v-show="callBidReqQualiList.length >0" class="ml10" style="color: blue;" @click="clearCallBidReqQualiList"> 清除所选 </a></span>
                                    <table class="custom-tbl" v-if="callBidReqQualiList.length > 0">
                                        <thead class="head">
                                        <tr class="row">
                                            <th width="">序号</th>
                                            <th width="">组号</th>
                                            <th width="200px">资质名称</th>
                                            <th width="">资质类型</th>
                                            <th width="">是否强制</th>
                                            <th width="">操作</th>
                                        </tr>
                                        </thead>
                                        <tbody class="body">
                                        <tr class="row" v-for="(callBidReqQuali, index) in callBidReqQualiList">
                                            <td>
                                                <div class="table-addr">
                                                    <span>{{index + 1}}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr">
                                                    <input style="width:100%;" type="text" v-model.number="callBidReqQuali.groupNo" v-on:blur="sortblur(callBidReqQuali)"/>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr">
                                                    <span>{{callBidReqQuali.qualiTypeName}}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr">
                                                    <span>{{qualiKindList[callBidReqQuali.qualiKind].text}}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr" @change="changeRadio(callBidReqQuali)">
                                                    <el-radio-group v-model="callBidReqQuali.mandatory">
                                                        <el-radio :label=false>否</el-radio>
                                                        <el-radio :label=true>是</el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr">
                                                    <a class="swb-btn-link" @click="delCallBidReqQuali(callBidReqQuali)">移除</a>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="form-group center">
                                <div class="form-label">
                                    <label>注册资金(含)</label>
                                </div>
                                <div class="form-value">
                                    <el-input class="width-1x" v-model="callBidDoc.reqRegCapital" placeholder="请输入内容"></el-input>&nbsp;&nbsp;<span>(万元)以上</span>
                                </div>
                            </div>

                            <div class="form-group center">
                                <div class="form-label">
                                    <label>成立时间</label>
                                </div>
                                <div class="form-value width-1-5x">
                                    <el-date-picker v-model="callBidDoc.foundDate" type="date" placeholder="选择日期"></el-date-picker>&nbsp;&nbsp;<span>之前</span>
                                </div>
                            </div>

                            <div class="form-group center">
                                <div class="form-label">
                                    <label>人员资质要求</label>
                                </div>
                                <div class="form-value">
                                    <a style="color: blue;" @click="selectStaffQualiTypes">[ 直接选择 ]</a>
                                    <a v-show="staffQualiTypes.length >0" class="ml10" style="color: blue;" @click="clearStaffQualiTypes"> 清除所选 </a>
                                    <table class="custom-tbl" v-if="staffQualiTypes.length > 0">
                                        <thead class="head">
                                        <tr class="row">
                                            <th width="">资质类型</th>
                                            <th width="">类型名称</th>
                                            <th width="200px">类型等级</th>
                                            <th width="">要求数量</th>
                                            <th width="">是否强制</th>
                                            <th width="">操作</th>
                                        </tr>
                                        </thead>
                                        <tbody class="body">
                                        <tr class="row" v-for="(staffQualiType, index) in staffQualiTypes">
                                            <td>
                                                <div class="table-addr">
                                                    <span>{{staffQualiType.name}}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr">
                                                    <span>{{staffQualiType.qualiName}}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr">
                                                    <span v-if="staffQualiType.qualiLevel == 1">一级</span>
                                                    <span v-if="staffQualiType.qualiLevel == 2">二级</span>
                                                    <span v-if="staffQualiType.qualiLevel == 3">三级</span>
                                                    <span v-if="staffQualiType.qualiLevel == 4">四级</span>
                                                    <span v-if="staffQualiType.qualiLevel == 5">五级</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr">
                                                    <input style="width:100%;" type="text" v-model.number="staffQualiType.quantity"/>
                                                    <!-- v-on:blur="sortblur(callBidReqQuali)" -->
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr" @change="changeStaffQualiRadio(staffQualiType)">
                                                    <el-radio-group v-model="staffQualiType.mandatory">
                                                        <el-radio :label=false>否</el-radio>
                                                        <el-radio :label=true>是</el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-addr">
                                                    <a class="swb-btn-link" @click="delStaffQualiType(staffQualiType)">移除</a>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <div class="content-caption dashed">
                            <span>商务条款</span>
                        </div>
                        <swb-create-trade-rule :comparedTradeRuleList="comparedTradeRuleList" :forBid=true :forGoods=true :forServc=true :type="type" ref="swb_create_trade_rule"></swb-create-trade-rule>
                    </fieldset>
                </div>
            </el-form>
            <div class="form-toolbar">
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="goBack()">返回</button>
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="goBack()">取消</button>
                <button class="swb-btn swb-btn-small" @click="saveCallBidDoc()">保存</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base';
    import { Vue, MsgBox, Routes } from '../../app.vues';
    import { openStaffQualiTypeDlg } from '../quali/selectDlg';
    //
    import retailerApi from '../../api/retailer'
    import callBidApi from '../../api/callBid'
    //
    import SwbCreateCallItem from './CreateCallItem';

    Vue.regist(SwbCreateCallItem);

    import SwbOrientationBidList from './OrientationBidList';

    Vue.regist(SwbOrientationBidList);

    import SwbFileUpload from '../ctrl/FileUpload';

    Vue.regist(SwbFileUpload);

    import SwbFileItem from '../ctrl/FileItem';

    Vue.regist(SwbFileItem);

    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';

    Vue.regist(SwbCreateTradeRule);

    import SwbCallBidNoticeSave from './CallBidNoticeSave';

    Vue.regist(SwbCallBidNoticeSave);

    import SwbCallBidDocList from './CallBidDocList';

    Routes.add(SwbCallBidDocList);

    //显示（合作）供应商、服务商 选择对话框
    import { showVendorServicerSelectDialog } from '../merchant/showSelectDlg'

    import { showQualiTypeSelectDialog } from '../quali/qualiTypeSelectDlg'

    import { openServicerSelectComnDlg } from '../servicer/selectDlg'
    import { openVendorSelectComnDlg } from '../vendor/selectDlg'

    function sortCallBidReqQuali(itemList) {
        itemList.sort(function (item1, item2) {
            var retValue = item1['groupNo'] - item2['groupNo'];
            if(retValue == 0) {
                retValue = item1['seqNo'] - item2['seqNo']
            }
            return retValue;
        });
        return itemList;
    }

    export default {
        name: 'swb-call-bid-doc-create',
        path: '/call/bid/doc/create',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        parentBreadcrumbUrl: '/call/bid/doc/list',
        customBreadcrumb: false,
        desc: '招标书-编辑',
        data: function () {
            var checkTitle = (rule, value, callback) => {
                if(Utils.isNoB(value)) {
                    callback(new Error('招标书标题不能为空'));
                } else {
                    callback();
                }
            };

            var checkDigest = (rule, value, callback) => {
                if(Utils.isNoB(value)) {
                    callback(new Error('内容摘要不能为空'));
                } else {
                    callback();
                }
            };

            var checkOpenTime = (rule, value, callback) => {
                if(Utils.isNoB(value)) {
                    callback(new Error('时间不能为空'));
                } else {
                    callback();
                }
            };
            var checkContactName = (rule, value, callback) => {
                if(Utils.isNoB(value)) {
                    callback(new Error('联系人不能为空'));
                } else {
                    callback();
                }
            };

            var checkTel = (rule, value, callback) => {
                if(!Utils.isPhoneNo(value)) {
                    callback(new Error('请输入正确的联系方式'));
                } else {
                    callback();
                }
            };
            var checkReqDeposit = (rule, value, callback) => {
                if(!Utils.isIntStr(value)) {
                    callback(new Error('输入的金额必须为整数'));
                } else {
                    callback();
                }
            };
            var checkContactEmail = (rule, value, callback) => {
                if(!Utils.isNoB(value)) {
                    if(!Utils.isEmail(value)) {
                        callback(new Error('请输入正确的电子邮箱'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            var checkBudgetAmount = (rule, value, callback) => {
                if(!Utils.isNoB(value)) {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确预算金额'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            return {
                callBidMerchantTypeMap: {},
                //
                callBidDoc: {
                    directed: false,
                    //选择所基于的
                    reqMerchantType: null,
                    callBidGoodsList: [],
                    callBidServcList: [],
                    enrollCloseTime: null,
                    openTime: null,
                    closeTime: null,
                    resultPublishTime: null,
                    enrollFree: true,
                    budgetFlag: 0,
                    callBidMerchantList: [],
                    foundDate: null,
                    reqDeposit: 0,
                },
                groupNoQualiIdsMap: {},
                type: 'callBid',
                directedMerchantType: null,
                directedMerchantList: [],
                fileList: [],
                qualiKindList: null,
                //{id, docId, qualiTypeId, qualiTypeName, mandatory}
                callBidReqQualiMerchantType: null,
                callBidReqQualiList: [],
                callBidReqQualMap: null,
                retailerStaffList: [],
                servicer: false,
                vendor: false,
                vendorType: 1,
                rules: {
                    title: [
                        {validator: checkTitle, trigger: 'blur'}
                    ],
                    openTime: [
                        {validator: checkOpenTime, trigger: 'blur'}
                    ],
                    closeTime: [
                        {validator: checkOpenTime, trigger: 'blur'}
                    ],
                    resultPublishTime: [
                        {validator: checkOpenTime, trigger: 'blur'}
                    ],
                    enrollCloseTime: [
                        {validator: checkOpenTime, trigger: 'blur'}
                    ],
                    contactTel: [
                        {validator: checkTel, trigger: 'blur'}
                    ],
                    digest: [
                        {validator: checkDigest, trigger: 'blur'}
                    ],
                    contactName: [
                        {validator: checkContactName, trigger: 'blur'}
                    ],
                    reqDeposit: [
                        {validator: checkReqDeposit, trigger: 'blur'}
                    ],
                    contactEmail: [
                        {validator: checkContactEmail, trigger: 'blur'}
                    ],
                    budgetAmount: [
                        {validator: checkBudgetAmount, trigger: 'blur'}
                    ],
                    enrollFee: [
                        {validator: checkBudgetAmount, trigger: 'blur'}
                    ]
                },
                callbidDocId: null,
                comparedTradeRuleList: [],
                // 人员资质类型
                staffQualiTypes: [],
                //
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
            }
        },
        created: function () {
            let callBidMerchantTypeMap = {};
            callBidMerchantTypeMap["Vendor"] = getEnumInfoWith('merchantType', 'name', 'Vendor');
            callBidMerchantTypeMap["Servicer"] = getEnumInfoWith('merchantType', 'name', 'Servicer');
            this.groupNoQualiIdsMap = Utils.KeyMap.from();
            this.qualiKindList = getEnumList("qualiKind");
            this.callBidMerchantTypeMap = callBidMerchantTypeMap;
            //
            let id = this.$route.query.callBidDocId;

            this.callbidDocId = id;
            if(null != id) {
                this.getCallBidDocInfo(id);
                this.getTradeRuleInfo(id);
            }
            this.getStaffByComId();
        },
        methods: {
            sortblur: function (row) {
                let callBidReqQualiList = this.callBidReqQualiList;
                callBidReqQualiList = sortCallBidReqQuali(callBidReqQualiList);
                for(let i = 0; i < callBidReqQualiList.length; i++) {
                    let callBidReqQuali = callBidReqQualiList[i];
                    if(callBidReqQuali.groupNo == row.groupNo) {
                        callBidReqQuali.mandatory = row.mandatory;
                    }
                }
                this.syncGroupNo(callBidReqQualiList);
                this.$set(this, 'callBidReqQualiList', callBidReqQualiList);
            },

            changeRadio: function (row) {
                console.log(row);
                let callBidReqQualiList = this.callBidReqQualiList;
                for(let i = 0; i < callBidReqQualiList.length; i++) {
                    let callBidReqQuali = callBidReqQualiList[i];
                    if(callBidReqQuali.groupNo == row.groupNo) {
                        callBidReqQuali.mandatory = row.mandatory;
                    }
                }
                this.$set(this, 'callBidReqQualiList', callBidReqQualiList);
//                let callBidReqQuali = callBidReqQualiList.find(index);
//                console.log(callBidReqQuali);
            },
            // 人员 资质类型 是否强制设置
            changeStaffQualiRadio: function (row) {
                console.log(row);
                let staffQualiTypes = this.staffQualiTypes;
                for(let i = 0; i < staffQualiTypes.length; i++) {
                    let staffQualiType = staffQualiTypes[i];
                    if(staffQualiType.id == row.id) {
                        staffQualiType.mandatory = row.mandatory;
                    }
                }
                this.staffQualiTypes = Utils.merge([], staffQualiTypes);
            },

            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    console.log(files);
                    for(let i = 0; i < files.length; i++) { // for 处理多文件上传...
                        let file = files[i];
                        let callBidFile = {};
                        callBidFile.name = file.fileName;
                        callBidFile.fileUuid = file.fileUuid;
                        callBidFile.fileExtName = file.fileExtName;
                        callBidFile.fileBrowseUrl = file.fileBrowseUrl;
                        callBidFile.fileDownloaddUrl = file.fileDownloadUrl;
                        callBidFile.fileMd5 = file.fileMd5;
                        callBidFile.tag = file.tag || Utils.genUniqueStr() + i;
                        self.fileList.push(callBidFile);
                    }
                } else {
                    this.$message.success(result.message);
                }
            },

            downloadDemoFile: function (fileDownloaddUrl) {
                Utils.downloadFile(getAppUrl(fileDownloaddUrl));
            },

            removeUpload: function (index) {
                this.fileList.removeAt(index.trackKey);
                return false;
            },

            echoUploadedFileInfo: function (fileInfo) {
                //
                let fileMap = this.fileList.toMap("tag");
                fileMap = Utils.KeyMap.from(fileMap);
                //
                let file = fileMap.get(fileInfo.tag);
                file.name = fileInfo.fileName;
                file.fileUuid = fileInfo.fileUuid;
                file.fileExtName = fileInfo.fileExt;
                file.fileBrowseUrl = fileInfo.fileBrowseUrl;
                file.fileDownloaddUrl = fileInfo.fileDownloadUrl;
                file.fileMd5 = fileInfo.fileMd5;
                file.tag = fileInfo.tag || Utils.genUniqueStr() + i;
                //
                fileMap.set(file.tag, file);
                let files = fileMap.values();
                //
                this.fileList = Utils.merge([], files);
            },

            //根据当前需求的服务/商品判断所需的商户类型
            getReqMerchantType() {
                let stuffFlag = this.$refs.swb_create_call_item.getSelFlags();
                return stuffFlag.servc ? this.callBidMerchantTypeMap["Servicer"].value : this.callBidMerchantTypeMap["Vendor"].value;
            },

            //清除要求的资质类型
            clearCallBidReqQualiList() {
                this.callBidReqQualiList = [];
                this.callBidReqQualiMerchantType == null;
            },
            //移除资质类型
            delCallBidReqQuali(quali) {
                let index = this.callBidReqQualiList.indexOf(quali, function (quali, elem) {
                    return quali.qualiTypeId == elem.qualiTypeId;
                });
                this.callBidReqQualiList.removeAt(index);

                let callBidReqQualiList1 = sortCallBidReqQuali(this.callBidReqQualiList);
                this.syncGroupNo(callBidReqQualiList1);
                this.$set(this, 'callBidReqQualiList', callBidReqQualiList1);
                //
                if(this.callBidReqQualiList.length == 0) {
                    this.callBidReqQualiMerchantType == null;
                }
            },
            // 选择要求的资质类型
            selectQualiTypes() {
                let self = this;
                //
                if(this.callBidReqQualiList.length == 0 || this.callBidReqQualiMerchantType == null) {
                    this.callBidReqQualiMerchantType = this.getReqMerchantType();
                }
                //
                let dlgArgs = {
                    merchantType: this.callBidReqQualiMerchantType,
                    multiSelect: true,
                    initCheckedItems: self.callBidReqQualiList.map(function (reqQuali) {
                        return {
                            id: reqQuali.qualiTypeId,
                            name: reqQuali.qualiTypeName
                        };
                    })
                };
                //
                showQualiTypeSelectDialog(dlgArgs, function (resultData) {
                    let retQualiTypes = resultData || [];
                    let retQualiList = retQualiTypes.map(function (qualiType) {
                        //组合构造结果数据
                        return {
                            qualiTypeId: qualiType.id,
                            qualiTypeName: qualiType.name,
                            qualiKind: qualiType.kind,
                            //默认值
                            mandatory: false
                        };
                    });
                    //比较函数
                    let isFunc = function (retQuali, reqQuali) {
                        return retQuali.qualiTypeId == reqQuali.qualiTypeId;
                    };
                    let eqFunc = isFunc;
                    let callBidReqQualiList = self.callBidReqQualiList.clone();
                    //比较结果差异

                    let groupNo = 0;
                    let groupNos = [];
                    for(let i = 0; i < callBidReqQualiList.length; i++) {
                        groupNos.push(callBidReqQualiList[i].groupNo);
                    }

                    for(let i = 0; i < groupNos.length; i++) {
                        var mxnArr = groupNos[i];
                        var mxnIndex = i;
                        var mxnItem = null;
                        for(let j = i + 1; j < groupNos.length; j++) {
                            mxnItem = groupNos[j];
                            if(mxnItem > mxnArr) {
                                mxnArr = mxnItem;
                                mxnIndex = j;
                            }
                        }
                        if(mxnIndex != i) {
                            var mxnItem = groupNos[i];
                            groupNos[mxnIndex] = mxnItem;
                            groupNos[i] = mxnArr;
                        }
                    }
                    if(groupNos.length > 0) {
                        groupNo = groupNos[0];
                    }
                    let diff = Utils.compareArrays(retQualiList, callBidReqQualiList, isFunc, eqFunc);
                    //console.log(diff);
                    let more = diff.more; //多的
                    let less = diff.less; //少的
                    for(let i = 0; i < more.length; i++) {
                        let quali = more[i];
                        quali.groupNo = groupNo + 1;
                        groupNo = groupNo + 1;
                        callBidReqQualiList.add(quali);
                    }
                    //
                    for(let i = 0; i < less.length; i++) {
                        let quali = less[i];
                        let index = callBidReqQualiList.indexOf(quali, function (quali, elem) {
                            return quali.qualiTypeId == elem.qualiTypeId;
                        });
                        callBidReqQualiList.removeAt(index);
                    }
                    self.syncGroupNo(callBidReqQualiList);
                    //
                    self.$set(self, 'callBidReqQualiList', callBidReqQualiList);
                    //
                    if(self.callBidReqQualiList.length == 0) {
                        self.callBidReqQualiMerchantType == null;
                    }
                }, self);
            },

            syncGroupNo: function (callBidReqQualiList) {
                let groupNoQualiIdsMap = {};
                for(let i = 0; i < callBidReqQualiList.length; i++) {
                    let callBidReqQuali = callBidReqQualiList[i];
                    let groupNo = callBidReqQuali.groupNo;
                    let quliTypeId = callBidReqQuali.qualiTypeId;
                    let qualiTypeIds = groupNoQualiIdsMap[groupNo];
                    if(qualiTypeIds == null) {
                        qualiTypeIds = [];
                        groupNoQualiIdsMap[groupNo] = qualiTypeIds;
                    }
                    qualiTypeIds.push(quliTypeId);
                }
                this.groupNoQualiIdsMap = groupNoQualiIdsMap;
            },

            // ====================== 人员资质要求选择 ============================
            selectStaffQualiTypes: function () {
                let self = this;
                let checkedList = [];
                let staffQualiTypes = self.staffQualiTypes;
                if(!Utils.isNoB(staffQualiTypes)) {
                    staffQualiTypes.forEach(function (result) {
                        let staffQualiType = {};
                        staffQualiType.id = result.qualiTypeId;
                        staffQualiType.selectLevel = result.qualiLevel;
                        //
                        checkedList.push(staffQualiType);
                    });
                }
                //
                let isRedio = false;
                let showLevels = true;
                let forMercht = 'forCallbid';
                openStaffQualiTypeDlg(checkedList, isRedio, showLevels, forMercht, function (result) {
                    console.log(result);
                    result.forEach(function (staffQualiType) {
                        // 数据组合
                        staffQualiType.quantity = 0;
                        staffQualiType.mandatory = true;
                        staffQualiType.qualiTypeId = staffQualiType.id;
                        staffQualiType.qualiLevel = staffQualiType.selectLevel;
                        staffQualiType.qualiName = staffQualiType.checkLevel.name;
                        //
                        self.staffQualiTypes.push(staffQualiType);
                    });
                });
            },
            //清除要求的资质类型
            clearStaffQualiTypes: function () {
                this.staffQualiTypes = [];
            },
            //移除资质类型
            delStaffQualiType(qualiType) {
                let staffQualiTypes = this.staffQualiTypes;
                let index = staffQualiTypes.indexOf(qualiType, function (quali, elem) {
                    return quali.id == elem.id;
                });
                staffQualiTypes.removeAt(index);
                //
                this.staffQualiTypes = Utils.merge([], staffQualiTypes);
            },
            //
            getStaffByComId: function () {
                let self = this;
                let postData = {};
                retailerApi.getRetailerStaffListByComId(postData, function (result) {
                    if(result.type === "info") {
                        self.retailerStaffList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            clearCallbidTargets() {
                this.directedMerchantType = null;
                this.$set(this, 'directedMerchantList', []);
            },
            showCallbidTargetsDialog() {
                let self = this;
                if(this.directedMerchantList.length == 0 || this.directedMerchantType == null) {
                    this.directedMerchantType = this.getReqMerchantType();
                }
                let initCheckedIds = this.directedMerchantList.pluck("id");
                //
                let directedMerchantTypeName = this.directedMerchantType == this.callBidMerchantTypeMap["Servicer"].value ? "服务商" : "供应商";
                // 回调显示
                let callback = function (resultData) {
                    resultData = resultData || [];
                    console.log(resultData);
                    if(!Utils.isArray(resultData)) {
                        resultData = [resultData];
                    }
                    //
                    if(resultData.length < 1) {
                        MsgBox.warning("请选择 " + directedMerchantTypeName);
                        return false;
                    }
                    else {
                        this.$set(this, 'directedMerchantList', resultData);
                    }
                };
                // 服务商
                let params = {
                    initCheckedIds: initCheckedIds,
                    multiSelect: true,
                    showContract: true, // 合同
                    showOrder: true, // 订单
                    showAmbilateralBizRel: true, // 双方关联
                    showBizRel: true, // 备选
                    showAdverseBizRel: true, // 买方关联，备选其他
                    showNoScoreBizRel: true, // 待入围
                    showShieldedBizRel: true, // 加黑
                    showAll: true // 全部
                };
                // 调用信息
                if(this.directedMerchantType == this.callBidMerchantTypeMap["Servicer"].value) {
                    // 服务商
                    openServicerSelectComnDlg(self, params, function (result) {
                        let resultData = result.checkedList || [];
                        callback.apply(self, [resultData]);
                    });
                } else {

                    //供应商
                    openVendorSelectComnDlg(self, params, function (result) {
                        let resultData = result.checkedList || [];
                        callback.apply(self, [resultData]);
                    });
                }
            },
            getCallBidDocInfo: function (id) {
                let self = this;
                let postData = {};
                postData.id = id;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let callBidDoc = result.data;
                        //
                        let callBidFileList = callBidDoc.callBidFileList || [];
                        let fileList = [];
                        for(var i = 0; i < callBidFileList.length; i++) {
                            let file = callBidFileList[i];
                            let callBidFile = {};
                            callBidFile.docId = file.docId;
                            callBidFile.name = file.name;
                            callBidFile.fileUuid = file.fileUuid;
                            callBidFile.fileExtName = file.fileExtName;
                            callBidFile.fileBrowseUrl = file.fileBrowseUrl;
                            callBidFile.fileDownloaddUrl = file.fileDownloadUrl;
                            callBidFile.fileMd5 = file.fileMd5;
                            callBidFile.tag = file.tag || Utils.genUniqueStr() + i;
                            fileList.push(callBidFile);
                        }
                        self.fileList = fileList;

                        //恢复定向商户对应的商户类型
                        self.directedMerchantType = callBidDoc.reqMerchantType;
                        //恢复选择的定向商户
                        let callBidMerchantList = callBidDoc.callBidMerchantList || [];
                        self.directedMerchantList = callBidMerchantList.map(function (merchant) {
                            return {
                                id: merchant.merchantId,
                                name: merchant.merchantName
                            };
                        });
                        //恢复资质对应的商户类型
                        self.callBidReqQualiMerchantType = callBidDoc.reqMerchantType;
                        //恢复选择的招标要求资质
                        let callBidReqQualiList = callBidDoc.callBidReqQualiList || [];
                        if(callBidReqQualiList.length > 0) {
                            callBidReqQualiList = sortCallBidReqQuali(callBidReqQualiList);
                            self.syncGroupNo(callBidReqQualiList);
                        }
                        self.callBidReqQualiList = callBidReqQualiList;
                        //恢复选择的招标要求人员资质
                        self.staffQualiTypes = callBidDoc.staffQualiList || [];
                        //
                        let reqRegCapital = callBidDoc.reqRegCapital || null;
                        if(typeof reqRegCapital == 'number') {
                            callBidDoc.reqRegCapital = (reqRegCapital / 10000).round(4);
                        }
                        //
                        self.callBidDoc = callBidDoc;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getTradeRuleInfo: function (id) {
                let self = this;
                let postData = {};
                postData.docId = id;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidTermList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let callBidTermList = result.data;
                        if(callBidTermList != null && callBidTermList.length > 0) {
                            self.comparedTradeRuleList = callBidTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                        }
                    }
                });
            },

            saveCallBidDoc: function () {
                let self = this;
                self.$refs['bidDoc'].validate(function (valid) {
                    if(valid) {
                        let callBidDoc = self.callBidDoc;
                        //
                        let postData = merge({}, callBidDoc);

                        //标题
                        if(Utils.isNoB(postData.title)) {
                            Toast.show('招标标题为必填项', 3000, 'warning');
                            return false;
                        }
                        postData.title = postData.title.trim();
                        callBidDoc['title'] = postData.title;

                        //预算
                        let budgetFlag = postData['budgetFlag'];
                        if(budgetFlag == 2) {
                            //
                            let budgetAmount = Utils.ParseInt(postData['budgetAmount']);
                            if(budgetAmount == null || budgetAmount <= 0) {
                                Toast.show('请指定固定预算 的金额', 3000, 'warning');
                                return false;
                            }
                            else {
                                postData['budgetAmount'] = budgetAmount;
                                //
                                callBidDoc['budgetAmount'] = budgetAmount;
                            }
                        }
                        else {
                            delete postData['budgetAmount'];
                        }
                        //
                        let stuffFlag = self.$refs.swb_create_call_item.getSelFlags() || {};

                        if(stuffFlag.goods || stuffFlag.servc) {
                            //商品
                            if(stuffFlag.goods) {
                                postData["goodsFlag"] = true;
                                //
                                postData["reqMerchantType"] = self.callBidMerchantTypeMap["Vendor"].value;
                                //
                                let resultGoods = self.$refs.swb_create_call_item.getDlgResultGoods() || {};
                                let callBidGoodsList = resultGoods['callBidGoodsList'] || [];
                                if(callBidGoodsList.length < 1) {
                                    Toast.show("请填写要招标的商品", 3000, 'warning');
                                    return;
                                }
                                else {
                                    for(let i = 0; i < callBidGoodsList.length; i++) {
                                        let callBidGoods = callBidGoodsList[i];
                                        if(Utils.isNoB(callBidGoods.name)) {
                                            Toast.show("商品名称为不能为空");
                                            return;
                                        }
                                        let validateGoods = self.$refs.swb_create_call_item.validateGoods(callBidGoods);
                                        if(validateGoods.type == "warn") {
                                            Toast.show("商品名称为【" + callBidGoods.name + "】" + validateGoods.message);
                                            return;
                                        }
                                    }
                                    postData['callBidGoodsList'] = callBidGoodsList;
                                }

                            }
                            else {
                                postData['callBidGoodsList'] = [];
                            }
                            //服务
                            if(stuffFlag.servc) {
                                postData["servcFlag"] = true;
                                //
                                postData["reqMerchantType"] = self.callBidMerchantTypeMap["Servicer"].value;
                                //
                                let resultServc = self.$refs.swb_create_call_item.getDlgResultService() || {};
                                let callBidServcList = resultServc['callBidServcList'] || [];
                                if(callBidServcList.length < 1) {
                                    Toast.show("请填写招标的服务", 3000, 'warning');
                                    return;
                                }
                                else {
                                    for(let i = 0; i < callBidServcList.length; i++) {
                                        let callBidServc = callBidServcList[i];
                                        if(Utils.isNoB(callBidServc.name)) {
                                            Toast.show("服务名称为不能为空");
                                            return;
                                        }
                                        let validateServc = self.$refs.swb_create_call_item.validateServc(callBidServc);
                                        if(validateServc.type == "warn") {
                                            Toast.show("服务名称为【" + callBidServc.name + "】" + validateServc.message);
                                            return;
                                        }
                                    }
                                    postData['callBidServcList'] = callBidServcList;
                                }
                            }
                            else {
                                postData['callBidServcList'] = [];
                            }
                        }
                        else {
                            Toast.show("必须指定 招商品 或 招服务", 3000, 'warning');
                            return;
                        }
                        //定向招标检查（定向商户）
                        let directed = postData["directed"];
                        if(directed) {
                            let directedMerchantList = self.directedMerchantList || [];
                            if(directedMerchantList.length < 1) {
                                Toast.show("定向招标必须指定对应的商户", 3000, 'warning');
                                return;
                            }
                            //
                            if(self.directedMerchantType == null) {
                                self.directedMerchantType = postData["reqMerchantType"];
                            }
                            //
                            if(self.directedMerchantType != postData["reqMerchantType"]) {
                                Toast.show("定向招标的【商户类型】与招标需求详情不对应，请确认（招服务 只能定向到 服务商，仅招商品 则只能定向到 供应商）。", 5000, 'warning');
                                return;
                            }
                            //
                            postData['callBidMerchantList'] = directedMerchantList.map(function (merchant) {
                                return {
                                    merchantId: merchant.id,
                                    merchantName: merchant.name,
                                    merchantType: postData["reqMerchantType"]
                                };
                            });
                        } else {
                            postData['callBidMerchantList'] = [];
                        }
                        //招标书 （内容摘要）
                        if(Utils.isNoB(postData.digest)) {
                            Toast.show('内容摘要为必填项', 3000, 'warning');
                            return false;
                        }
                        //招标书（附件）
                        if(self.fileList.length <= 0) {
                            Toast.show('招标书附件不能为空', 3000, 'warning');
                            return false;
                        }
                        postData['callBidFileList'] = (self.fileList || []).map(function (item) {
                            return Utils.merge({}, item);
                        });

                        //报名截止时间
                        let enrollCloseTime = Date.parseAsDate(postData['enrollCloseTime']) || null;
                        if(enrollCloseTime == null) {
                            Toast.show('请 指定 报名截止时间', 3000, 'warning');
                            return false;
                        }
                        enrollCloseTime = postData['enrollCloseTime'] = enrollCloseTime.format('yyyy-MM-dd HH:mm');

                        //投标开始时间/资格预审结束
                        let openTime = Date.parseAsDate(postData['openTime']) || null;
                        if(openTime == null) {
                            Toast.show('请 指定 资格预审结束 时间', 3000, 'warning');
                            return false;
                        }
                        openTime = postData['openTime'] = openTime.format('yyyy-MM-dd HH:mm');

                        //投标结束时间/投标截止时间
                        let closeTime = Date.parseAsDate(postData['closeTime']) || null;
                        if(closeTime == null) {
                            Toast.show('请 指定 投标截止时间', 3000, 'warning');
                            return false;
                        }
                        closeTime = postData['closeTime'] = closeTime.format('yyyy-MM-dd HH:mm');

                        //结果公布时间
                        let resultPublishTime = Date.parseAsDate(postData['resultPublishTime']) || null;
                        if(resultPublishTime == null) {
                            Toast.show('请 指定 结果公布时间', 3000, 'warning');
                            return false;
                        }
                        resultPublishTime = postData['resultPublishTime'] = resultPublishTime.format('yyyy-MM-dd HH:mm');

                        //
                        if(openTime < enrollCloseTime) {
                            Toast.show('资格预审结束时间 必须 晚于 报名截止时间', 3000, 'warning');
                            return false;
                        }
                        if(closeTime < openTime) {
                            Toast.show('投标截止时间 必须 晚于 资格预审结束时间', 3000, 'warning');
                            return false;
                        }
                        if(resultPublishTime < closeTime) {
                            Toast.show('结果公布时间 必须 晚于 投标截止时间', 3000, 'warning');
                            return false;
                        }

                        //保证金
                        let enrollFree = postData['enrollFree'];
                        if(!enrollFree) {
                            let enrollFee = Utils.ParseInt(postData['enrollFee']);
                            if(enrollFee == null || enrollFee <= 0) {
                                Toast.show('请 填写报名保证金', 3000, 'warning');
                                return false;
                            }
                            else {
                                postData['enrollFee'] = enrollFee;
                                //
                                callBidDoc['enrollFee'] = enrollFee;
                            }
                        }
                        else {
                            delete postData['enrollFee'];
                        }
                        if(Utils.isNoB(postData.contactName)) {
                            Toast.show('联系人不能为空');
                            return false;
                        }
                        if(!Utils.isPhoneNo(postData.contactTel)) {
                            Toast.show('请输入正确的联系方式');
                            return false;
                        }
                        if(!Utils.isNoB(postData.contactEmail)) {
                            if(!Utils.isEmail(postData.contactEmail)) {
                                Toast.show('请输入正确的电子邮箱');
                                return false;
                            }
                        }
                        if(!Utils.isIntStr(postData.reqDeposit)) {
                            Toast.show('请输入正确的电子邮箱');
                            return false;
                        }

                        //资质类型要求
                        let callBidReqQualiList = self.callBidReqQualiList || [];
                        for(let i = 0; i < callBidReqQualiList.length; i++) {
                            let callBidReqQuali = callBidReqQualiList[i];
                            if(!Utils.isNaturalStr(callBidReqQuali.groupNo)) {
                                Toast.show('资质名称为【' + callBidReqQuali.qualiTypeName + '】的组号不是整数', 3000, 'warning');
                                return false;
                            }
                        }
                        /*                if(callBidReqQualiList.length < 1) {
                         Toast.show("请选择 招标要求的资质", 3000, 'warning');
                         return false;
                         }*/
                        /*let qualiTypeIdCallBidReqQualiMap = {};
                         for(let i = 0; i < callBidReqQualiList.length; i++) {
                         let callBidReqQuali = callBidReqQualiList[i];
                         qualiTypeIdCallBidReqQualiMap[callBidReqQuali.qualiTypeId] = callBidReqQuali;
                         }
                         //TODO 目前接收的仅仅是资质类型的id
                         let newCallBidReqQualiList = [];
                         let groupNoQualiIdsMap = self.groupNoQualiIdsMap;
                         let groupNos = [];
                         for(let key in groupNoQualiIdsMap) {
                         groupNos.push(key);
                         }
                         for(let k = 0; k < groupNos.length; k++) {
                         let groupNo = groupNos[k];
                         let qualiTypeIds = groupNoQualiIdsMap[groupNo];
                         if(qualiTypeIds.length > 1) {
                         for(let j = 0; j < qualiTypeIds.length; j++) {
                         let qualiTypeId = qualiTypeIds[j];
                         let callBidReqQuali = qualiTypeIdCallBidReqQualiMap[qualiTypeId];
                         callBidReqQuali.mandatory = true;
                         newCallBidReqQualiList.push(callBidReqQuali);
                         }
                         } else {
                         let callBidReqQuali = qualiTypeIdCallBidReqQualiMap[qualiTypeIds[0]];
                         newCallBidReqQualiList.push(callBidReqQuali);
                         }
                         }*/
                        postData['callBidReqQualiList'] = callBidReqQualiList;
                        //
                        console.log(self.staffQualiTypes);
                        let staffQualiTypes = self.staffQualiTypes || [];
                        for(let i = 0; i < staffQualiTypes.length; i++) {
                            let staffQualiType = staffQualiTypes[i];
                            if(!Utils.isNaturalStr(staffQualiType.quantity)) {
                                Toast.show('资质类型为【' + staffQualiType.name + '】的数量不是正整数', 3000, 'warning');
                                return false;
                            }
                        }
                        postData['staffQualiList'] = staffQualiTypes;
                        //检查资质类型对应的商户类型
                        if(self.callBidReqQualiMerchantType == null) {
                            self.callBidReqQualiMerchantType = postData["reqMerchantType"];
                        }
                        //
                        if(self.callBidReqQualiMerchantType != postData["reqMerchantType"]) {
                            Toast.show("定招标资质要求的【商户类型】与招标需求详情不对应，请确认（招服务 只能选择 服务商资质，仅招商品 则只能选择 供应商资质）。", 5000, 'warning');
                            return;
                        }
                        //注册资金
                        let reqRegCapital = Utils.ParseFloat(postData['reqRegCapital']);
                        if(reqRegCapital != null) {
                            callBidDoc['reqRegCapital'] = reqRegCapital.toFixed(4);
                            postData['reqRegCapital'] = Math.round(reqRegCapital.toFixed(4) * 10000);
                        }
                        //成立日期
                        let foundDate = Date.parseAsDate(postData['foundDate']) || null;
                        if(foundDate != null) {
                            postData['foundDate'] = foundDate.format('yyyy-MM-dd');
                        }

                        //商务条款
                        let resultTerm = self.$refs.swb_create_trade_rule.getResult() || {};
                        if(resultTerm.type == 'info') {
                            postData['callBidTermList'] = resultTerm.data || [];
                        }
                        else {
                            postData['callBidTermList'] = [];
                            return;
                        }

                        //
                        let lastMsgBoxDlg = MsgBox.loading();
                        callBidApi.createCallBidDoc(postData, function (result) {
                            if(result.type == 'info') {
                                MsgBox.success("保存招标书成功");
                                self.goBackPage();
                            } else {
                                MsgBox.failure(result.message);
                            }
                            lastMsgBoxDlg.hide();
                        });
                    }
                });
            },

            goBack: function () {
                let self = this;
                let checkState = this.$route.query.checkState;
                this.$router.push({
                    path: SwbCallBidDocList.path,
                    query: {
                        checkState: checkState,
                    }
                });
            },
            goBackPage: function () {
                this.$router.push({
                    path: SwbCallBidDocList.path
                });
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidDocCreate.vue